import React, { useRef, useState, useEffect } from "react";

import step1 from "../../../assets/overview_img/Platformimg/how-it-works-employers-1.webp";
import step2 from "../../../assets/overview_img/Platformimg/how-it-works-employers-2-1.webp";
import step3 from "../../../assets/overview_img/Platformimg/how-it-works-employers-3.webp";

function HowItWorks() {
  const sliderRef = useRef(null);

  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      number: "1",
      title: "Integrate & Launch",
      desc: "DailyPay connects to your existing payroll system and launches to your employees right away.",
      image: step1,
    },

    {
      number: "2",
      title: "Manage with the Client Portal",
      desc: "Gain real-time insights into your team's usage, transactions, and engagement with a user-friendly dashboard.",
      image: step2,
    },

    {
      number: "3",
      title: "Enhance Your Pay Strategy",
      desc: "Go beyond On-Demand Pay. Use features like Cycle for off-cycle payments, Reward for instant bonuses, and Tips for same-day payouts.",
      image: step3,
    },
  ];

  // CLICK ON NUMBER
  const handleStepClick = (index) => {
    setActiveStep(index);

    if (window.innerWidth >= 1024) {
      sliderRef.current?.scrollTo({
        // top: index * 720,
        top:
  index *
  (sliderRef.current.scrollHeight / steps.length),
        behavior: "smooth",
      });
    }
  };

  // AUTO CHANGE ACTIVE STEP ON SCROLL
  useEffect(() => {
    const slider = sliderRef.current;

    if (!slider) return;

    const handleScroll = () => {
      const scrollTop = slider.scrollTop;

      // const stepHeight = 720;

      const stepHeight =
  slider.scrollHeight / steps.length;

      const currentStep = Math.round(scrollTop / stepHeight);

      setActiveStep(currentStep);
    };

    slider.addEventListener("scroll", handleScroll);

    return () => {
      slider.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
<section className="bg-white py-10 lg:py-0 overflow-visible -mb-16 lg:-mb-0 lg:-mt-0">
        <div
        className="
          max-w-[1450px]
          mx-auto
          px-4
          sm:px-6
          lg:px-10
        "
      >
        {/* ================= MOBILE/TABLET ================= */}
        <div className="lg:hidden">
          <div className="max-w-[700px] lg:max-w-[700px]  lg:-mt-0 over">
        <h2
  className="
    text-[#290001]
    font-serif

    text-[22px]
    sm:text-[34px]
    md:text-[28px]
    md:font-serif
    md:tracking-tighter
    lg:text-[50px]
    lg:font-bold

    leading-[24px]
    sm:leading-[40px]
    md:leading-[48px]
    lg:leading-[56px]
    xl:leading-[1.1]
    max-w-[700px]
    -mt-[50px]
  "
>
  How It Works for Employers
</h2>

            <p
              className="
                mt-5
          
                text-[#1e1c1c]

                text-[16px]
                md:text-[16px]
                md:font-[400]
                md:text-black
                lg:text-[16px]

                leading-[1.5]
                lg:leading-[1]
                max-w-full
              "
            >
              Using DailyPay is a simple, three-step process designed to give you more flexibility and control.
            </p>
          </div>
        </div>

        <div className="mt-10 space-y-10 lg:hidden">
          {steps.map((step, index) => (
            <div key={index}>
              {/* IMAGE */}
              <div className="flex justify-center">
                <img
                  src={step.image}
                  alt=""
                  className="
                    w-full
                    max-w-[360px]
                    h-auto
                    object-contain
                  "
                />
              </div>

              {/* CONTENT */}
              <div className="mt-6 flex gap-4 lg:gap-6">
                <div
                  className="
                    min-w-[34px]
                    h-[34px]

                    rounded-full
                    bg-orange-600
                    text-white

                    flex
                    items-center
                    justify-center

                    text-[16px]
                    font-bold
                  "
                >
                  {step.number}
                </div>

                <div>
                  <h3
                    className="
                      text-[24px]
                      lg:text-[28px]
                      leading-[34px]

                      font-serif
                      text-[#290001]
                    "
                  >
                    {step.title}
                  </h3>

                  <p
                    className="
                      mt-4

                      text-[17px]
                      leading-[1.7]

                      text-[#290001]
                    "
                  >
                    {step.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}

          <button
            className="
              bg-[#3b0000]
              text-white
              lg:-mt-0
              ml-[50px]
            
              px-8
              py-3
              lg:px-8
              lg:py-3

              rounded-[2px]

              text-[16px]
              font-semibold
            "
          >
            Get a Demo
          </button>
        </div>

        {/* ================= DESKTOP ================= */}
        <div
          className="
            hidden
            lg:grid

            grid-cols-2
            gap-20

            
            items-start
          "
        >
          {/* LEFT STICKY SCROLLABLE IMAGES */}
          <div className="sticky top-[120px] h-fit">
            <div
              ref={sliderRef}
              className="
                h-[720px]
                overflow-y-auto
                scroll-smooth

                [scrollbar-width:none]
                [-ms-overflow-style:none]
              "
            >
              <style>
                {`
                  .hide-scrollbar::-webkit-scrollbar {
                    display: none;
                  }
                `}
              </style>

              <div className="hide-scrollbar space-y-10">
                {steps.map((step, index) => (
                  <div
                    key={index}
                    className="
                      min-h-[520px]

                      bg-[white]
                      rounded-[20px]
                      md:rounded-[34px]
                      lg:rounded-[5px]
                      overflow-hidden

                      flex
                      items-center
                      justify-center
                    "
                  >
                    <img
                      src={step.image}
                      alt=""
                      className="
                        w-full
                        h-full
                        object-cover
                      "
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT */}
<div className="pt-4 lg:pt-2 text-[#290001]">           
   <div className="hidden lg:block max-w-[560px] mb-12">
              <h2
                className="
                  text-[#290001]
                  font-serif

                  text-[28px]
                  sm:text-[36px]
                  lg:text-[32px]

                  leading-[34px]
                  sm:leading-[42px]
                  lg:leading-[1.0]
                "
              >
                How It Works for Employers
              </h2>

              <p
                className="
                  mt-2
                  lg:mt-6

                  text-[#290001]
                  md:text-[#290001]
                  lg:text-[#290001]

                  text-[15px]
                  sm:text-[16px]
                  lg:text-[17px]

                  leading-[1.7]
                  max-w-[520px]
                "
              >
                Using DailyPay is a simple, three-step process designed to give you more flexibility and control.
              </p>
            </div>

<div className="space-y-8 lg:space-y-0">          
      {steps.map((step, index) => (
                <div
                  key={index}
                  onClick={() => handleStepClick(index)}
                  className="
                    flex
                    gap-8

                    cursor-pointer
                    group
                  "
                >
                  {/* NUMBER */}
                  <div className="flex flex-col items-center">
                    <div
                      className={`
                        w-[42px]
                        h-[42px]

                        rounded-full

                        flex
                        items-center
                        justify-center

                        text-[22px]
                        font-bold

                        transition-all
                        duration-300

                        ${
                          activeStep === index
                            ? "bg-cyan-400 text-black"
                            : "bg-white border border-gray-300 text-black"
                        }
                      `}
                    >
                      {step.number}
                    </div>

                    {index !== steps.length - 1 && (
                      <div className="w-[1px] h-[120px] bg-gray-300 mt-4" />
                    )}
                  </div>

                  {/* TEXT */}
                  <div>
                    <h3
                      className="
                        text-[22px]
                        leading-[1.0]

                        font-serif
                        text-[#290001]
                        sm:text-[#290001]
                        md:text-[#290001]
                        lg:text-[#290001]
                      "
                    >
                      {step.title}
                    </h3>

                    <p
                      className="
                        mt-5

                        text-[16px]
                        lg:text-[18px]
                        leading-[1.4]

                        text-[#290001]
                        md:text-[#290001]
                        sm:text-[#290001]
                        max-w-[520px]
                      "
                    >
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* BUTTON */}
            <button
              className="
                lg:mt-6
                bg-[#290001]
                text-white
                px-6
                lg:px-6
                py-2
                lg:py-2.5
                text-[18px]
                font-semibold
                hover:bg-[#500809]
                transition-all
                duration-300
                -ml-[50px]
                lg:-ml-0
              "
            >
              Get a Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;